const grnEn = {
    grnMaster: require('../../lang/en/grn/GrnMaster').default,
};

export default grnEn;
